import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Download, Star } from "lucide-react";
import { FiltersBar, useReportFilters, downloadCsv } from "@/components/ConversationsReport";
import { toast } from "sonner";

const Stars = ({ v }) => (
  <span className="inline-flex">{[1, 2, 3, 4, 5].map((i) => <Star key={i} className={`w-3.5 h-3.5 ${i <= Math.round(v) ? "text-amber-500 fill-amber-500" : "text-muted-foreground/30"}`} />)}</span>
);

export const RatingsReport = () => {
  const { f, setF, users, params } = useReportFilters();
  const [data, setData] = useState(null);
  const p = { start: params.start, end: params.end, user_id: params.user_id };
  const search = () => api.get("/reports/ratings", { params: p }).then(({ data }) => setData(data)).catch((e) => toast.error(e.response?.data?.detail || "Falha"));
  useEffect(() => { search(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="space-y-4">
      <FiltersBar f={f} setF={setF} users={users} onSearch={search} contact={false}>
        <Button size="sm" variant="outline" className="ml-auto" onClick={() => downloadCsv("/reports/ratings", { ...p, format: "csv" }, "avaliacoes.csv")} data-testid="report-export-ratings"><Download className="w-4 h-4 mr-1" /> Exportar</Button>
      </FiltersBar>
      {data && (
        <>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            <Card><CardContent className="p-5">
              <div className="text-xs uppercase font-semibold tracking-wider text-muted-foreground">Média geral</div>
              <div className="heading text-3xl font-extrabold" data-testid="ratings-avg">{data.avg ?? "—"}</div>
              {data.avg && <Stars v={data.avg} />}
            </CardContent></Card>
            <Card><CardContent className="p-5">
              <div className="text-xs uppercase font-semibold tracking-wider text-muted-foreground">Avaliações</div>
              <div className="heading text-3xl font-extrabold" data-testid="ratings-total">{data.total}</div>
            </CardContent></Card>
          </div>
          <Card><CardContent className="p-0">
            {data.by_attendant.length === 0 && <div className="p-8 text-center text-sm text-muted-foreground">Nenhuma avaliação no período. Ative a avaliação em Configurações.</div>}
            {data.by_attendant.map((b) => (
              <div key={b.name} className="flex flex-wrap items-center gap-4 p-4 border-b border-border" data-testid="ratings-attendant-row">
                <div className="font-semibold min-w-[160px]">{b.name}</div>
                <Stars v={b.avg} /> <span className="mono text-sm font-bold">{b.avg}</span>
                <span className="text-xs text-muted-foreground">{b.count} avaliação(ões)</span>
                <div className="flex gap-2 ml-auto text-[11px] text-muted-foreground">
                  {Object.entries(b.dist).map(([k, v]) => <span key={k}>{k}★ {v}</span>)}
                </div>
              </div>
            ))}
          </CardContent></Card>
          {data.items.length > 0 && (
            <Card><CardContent className="p-0">
              {data.items.slice(0, 50).map((r) => (
                <div key={r.id} className="flex items-center gap-3 px-4 py-2 border-b border-border/60 text-sm" data-testid="ratings-item">
                  <Stars v={r.score} />
                  <span className="font-medium">{r.contact_name}</span>
                  <span className="text-xs text-muted-foreground">· {r.user_name || "—"}</span>
                  <span className="text-xs text-muted-foreground ml-auto">{new Date(r.created_at).toLocaleString("pt-BR")}</span>
                </div>
              ))}
            </CardContent></Card>
          )}
        </>
      )}
    </div>
  );
};
